export default __webpack_public_path__ + "static/media/holistic_nutrition_topic.7b81093f.jpg";